module.exports = __webpack_public_path__ + "img/cgjz-3.e7a27b01.jpg";